/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Listing_Category_Digital_EducationInputs */

const en_listing_category_digital_education = /** @type {(inputs: Listing_Category_Digital_EducationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Education`)
};

const es_listing_category_digital_education = /** @type {(inputs: Listing_Category_Digital_EducationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Educación`)
};

const fr_listing_category_digital_education = /** @type {(inputs: Listing_Category_Digital_EducationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Éducation`)
};

const de_listing_category_digital_education = /** @type {(inputs: Listing_Category_Digital_EducationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bildung`)
};

const ja_listing_category_digital_education = /** @type {(inputs: Listing_Category_Digital_EducationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`教育`)
};

const zh_listing_category_digital_education = /** @type {(inputs: Listing_Category_Digital_EducationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`教育`)
};

const ar_listing_category_digital_education = /** @type {(inputs: Listing_Category_Digital_EducationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تعليم`)
};

const id_listing_category_digital_education = /** @type {(inputs: Listing_Category_Digital_EducationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pendidikan`)
};

const it_listing_category_digital_education = /** @type {(inputs: Listing_Category_Digital_EducationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Educazione`)
};

const ru_listing_category_digital_education = /** @type {(inputs: Listing_Category_Digital_EducationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Образование`)
};

const pt_listing_category_digital_education = /** @type {(inputs: Listing_Category_Digital_EducationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Educação`)
};

const ko_listing_category_digital_education = /** @type {(inputs: Listing_Category_Digital_EducationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`교육`)
};

/**
* | output |
* | --- |
* | "Education" |
*
* @param {Listing_Category_Digital_EducationInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const listing_category_digital_education = /** @type {((inputs?: Listing_Category_Digital_EducationInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Listing_Category_Digital_EducationInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_listing_category_digital_education(inputs)
	if (locale === "es") return es_listing_category_digital_education(inputs)
	if (locale === "fr") return fr_listing_category_digital_education(inputs)
	if (locale === "de") return de_listing_category_digital_education(inputs)
	if (locale === "ja") return ja_listing_category_digital_education(inputs)
	if (locale === "zh") return zh_listing_category_digital_education(inputs)
	if (locale === "ar") return ar_listing_category_digital_education(inputs)
	if (locale === "id") return id_listing_category_digital_education(inputs)
	if (locale === "it") return it_listing_category_digital_education(inputs)
	if (locale === "ru") return ru_listing_category_digital_education(inputs)
	if (locale === "pt") return pt_listing_category_digital_education(inputs)
	return ko_listing_category_digital_education(inputs)
});